import {
  FlexSummaryInset,
  LogoSpinner,
  MarginlessBody2Secondary,
  ReviewDataRow,
} from 'modules/frequencyManagement/components/optimize/Optimize.styles';
import { OptimizePendingReviewTestId } from 'modules/frequencyManagement/components/optimize/Optimize.constants';

export const OptimizeResultsDocumentation = 'TBD';

export const OptimizePendingReview = () => {
  return (
    <FlexSummaryInset data-test={OptimizePendingReviewTestId}>
      <ReviewDataRow>
        <LogoSpinner size={16} />
        <MarginlessBody2Secondary>
          Your audience distribution by optimal cap is being calculated... You&apos;ll see your
          results here soon
        </MarginlessBody2Secondary>
      </ReviewDataRow>
    </FlexSummaryInset>
  );
};
